#@import Booking.Presenters.Base
#@export Booking.Presenters.Booker

class Booking.Presenters.Booker extends Booking.Presenters.Base

  userPageHref: (page) ->
    "/users/#{@model.getUserId()}/#{page}"

  toHash: ->

    error = @model.getError()

    hash =
      error:                                  error
      errorLoading:                           error is 'loading' or error is 'timeout'
      errorBooking:                           error is 'server' or error is 'not_found'
      errorSegmentNotAvailable:               error is 'conflict'
      errorSegmentExpired:                    error is 'gone'
      myReservationsLink:                     @generateLink('.my_reservations', @userPageHref('reservations'))
      myGrouponsLink:                         @generateLink('.my_groupons', @userPageHref('groupons'))
      isLocked:                               @options.isLocked
      phoneRequired:                          @model.requirePhone()
      textNotificationsRequired:              @model.requireTextNotifications()
      questionRequired:                       @model.requireQuestion()
      isARSE:                                 @model.isARSE()
      isDTF:                                  @model.getIsDTF()
      isMW:                                   @model.isMultiWindow()
      showNewOverlay:                         @options.showNewOverlay
      hasReservation:                         @model.getReservation()?.id?
      merchantPhone:                          @model.getMerchantPhoneNumber()
      schedulingNoun:                         @getSchedulingNoun {}
      schedulingNounPlural:                   @getSchedulingNoun plural: true
      schedulingNounCapitalized:              @getSchedulingNoun capitalized: true
      schedulingNounWithDeterminer:           @getSchedulingNoun withDeterminer: true
      schedulingNounCapitalizedWithDeterminer:@getSchedulingNoun capitalized: true, withDeterminer: true

    hash

  localesBasePath: ->
    if @model.isARSE()
      "modules.#{@module}.#{@templateName}_arse"
    else
      "modules.#{@module}.#{@templateName}"
